export const maxShareCalculator = (totalShare, requestedShares, ownedEquity) => {
  let userPurchasedShare = (Number(totalShare) * Number(ownedEquity)) / 100;
  const sharesRemainingToPurchase = Number(((Number(totalShare) * 9.8) / 100 - userPurchasedShare - Number(requestedShares)).toFixed(2));
  return sharesRemainingToPurchase;
};

export const maxShareCalculatorWithNoOfShare = (totalShare, requestedShares, userPurchasedShare) => {
  const sharesRemainingToPurchase = Number(((Number(totalShare) * 9.8) / 100 - Number(userPurchasedShare) - Number(requestedShares)).toFixed(2));
  return sharesRemainingToPurchase;
};

export const maxShareCalculatorForSecondary = (totalShare, userPurchasedShare, remainingOpenShares) => {
  const sharesRemainingToPurchase = Number(((Number(totalShare) * 9.8) / 100 - Number(userPurchasedShare) - Number(remainingOpenShares)).toFixed(2));
  return sharesRemainingToPurchase;
}
